'use client'
import React from 'react'
import { CardDesc, Form, FormButton, FormContainer, FormContent1, FormH1 } from '../CustomForm/CustomFormElements'
import Modal from '../Modal'
import { useModal } from '../Modal/ModalContext'
import { ModalBox } from '../Modal/ModalElements'

const OptionModal = ({heading, additionalText, children, onCancel}) => {
    const {contentModal, isOpen, toggleModal} = useModal()
  return (
    <>
        <div style={{color: 'white'}}>
            <ModalBox isOpen={true}>
                <FormH1>
                    {heading}
                </FormH1>
                <FormContent1>
                    <CardDesc style={{marginBottom: '2%'}}>{additionalText}</CardDesc>
                    {children}
                </FormContent1>
                {onCancel && <FormButton to='#' transparent={true} onClick={onCancel}>Cancel</FormButton>}
            </ModalBox>
        </div>
    </>
  )
}

export default OptionModal